<script>
import { mapGetters } from 'vuex';
import { isImminent, isEnded } from '../../../utils/Time';
import TabGroup from '../../Tabs/TabGroup.vue';
import EventSelectionModalForm from './EventSelectionModalForm.vue';
import SelectionBlackbookModal from './SelectionBlackbookModal.vue';
import RelativeTime from '../../RelativeTime/RelativeTime.vue';
import EventSelectionModalOdds from './EventSelectionModalOdds.vue';
export default {
  name: 'EventSelectionModal',
  components: {
    TabGroup,
    EventSelectionModalForm,
    SelectionBlackbookModal,
    RelativeTime,
    EventSelectionModalOdds,
  },
  data() {
    return {
      isShortListed: false,
      isBlackBooked: false,
    };
  },
  computed: {
    ...mapGetters({
      eventData: 'FormGuideEventCard/getEventData',
      selectionModalData: 'FormGuideEventCard/getSelectionModalData',
      selectionModalActive: 'FormGuideEventCard/getSelectionModalStatus',
      blackbookModalActive: 'FormGuideEventCard/getBlackbookModalStatus',
      meetingName: 'FormGuideEventCard/getMeetingName',
      isFirstSelection: 'FormGuideEventCard/isFirstSelection',
      isLastSelection: 'FormGuideEventCard/isLastSelection',
      raceType: 'FormGuideEventCard/getRaceType',
      tabIndex: 'FormGuideEventCard/getSelectionModalTabIndex',
    }),
    competitor() {
      return this.selectionModalData.competitor || {};
    },
    jockey() {
      return this.selectionModalData.jockey || {};
    },
    trainer() {
      return this.selectionModalData.trainer || {};
    },
    competitorString() {
      const { selectionModalData, competitor } = this;
      return selectionModalData && competitor
        ? `${selectionModalData.competitor_number}. ${competitor.name} (${selectionModalData.barrier_number})`
        : '';
    },
    jockeyName() {
      const { jockey } = this;
      const { first_names, last_name, short_name } = jockey;
      return first_names && last_name ? `${first_names} ${last_name}` : `${short_name}`;
    },
    trainerName() {
      const { trainer } = this;
      const { first_names, last_name, short_name } = trainer;
      return first_names && last_name ? `${first_names} ${last_name}` : `${short_name}`;
    },
    startTime() {
      return this.eventData ? this.eventData.start_time : '';
    },
    isResulted() {
      return this.eventData ? this.eventData.is_resulted === 1 : false;
    },
    // is within an hour of starting
    isImminent() {
      return isImminent(this.startTime);
    },
    // start time is in the past
    isEnded() {
      return isEnded(this.startTime);
    },
    isHarness() {
      return this.raceType === 'harness';
    },
    winFlucsData() {
      const { averageWinOdds } = this.selectionModalData;
      return averageWinOdds && averageWinOdds.length > 0 && averageWinOdds[0].price
        ? averageWinOdds[0].price.fluctuations
        : [];
    },
    placeFlucsData() {
      const { averagePlaceOdds } = this.selectionModalData;
      return averagePlaceOdds && averagePlaceOdds.length > 0 && averagePlaceOdds[0].price
        ? averagePlaceOdds[0].price.fluctuations
        : [];
    },
    orderedSelectionWinOdds() {
      const { selectionModalData } = this;
      const selectionOdds = selectionModalData.bookmakerWinOdds || [];
      return selectionOdds.length > 0 ? selectionOdds.sort((a, b) => b.price.value - a.price.value) : [];
    },
    orderedSelectionPlaceOdds() {
      // get selection odds and order by highest price
      const { selectionModalData } = this;
      const selectionOdds = selectionModalData.bookmakerPlaceOdds || [];
      return selectionOdds.length > 0 ? selectionOdds.sort((a, b) => b.price.value - a.price.value) : [];
    },
  },
  methods: {
    toggleSelectionModal(tabIndex) {
      this.$store.dispatch('FormGuideEventCard/toggleSelectionModal', tabIndex);
    },
    toggleShortList() {
      this.isShortListed = !this.isShortListed;
    },
    toggleBlackBook() {
      this.isBlackBooked = !this.isBlackBooked;
    },
    updateModalData(direction, disabled) {
      if (!disabled) {
        this.$store.dispatch('FormGuideEventCard/updateModalData', {
          selectionId: this.selectionModalData.id,
          direction,
        });
      }
    },
  },
};
</script>

<template>
  <div
    :class="{'select-modal--active' : selectionModalActive, 'select-bb-modal--active': blackbookModalActive}"
    class="event-select-modal-container"
  >
    <div class="event-select-modal-header">
      <a class="event-select-modal-header__close" href="#" @click.prevent="toggleSelectionModal(0)">
        <span class="event-select-modal-header__close-icon"></span>
      </a>
      <div class="event-select-modal-header__title">{{ meetingName }}</div>
      <div class="event-select-modal-header__right">
        <div :class="{'align-right' : isHarness}" class="event-select-modal-header__right-items">
          <div class="event-select-modal-header__time">
            <RelativeTime
              v-if="isImminent || isEnded"
              :brand="`punters`"
              :target-time="startTime"
              :is-resulted="isResulted"
            />
          </div>
          <a
            v-if="!isHarness"
            :class="[{ filled: isBlackBooked }, 'event-select-modal-header__blackbook outline']"
            href="#"
            @click.prevent="toggleBlackBook"
          ></a>
          <a
            v-if="!isHarness"
            :class="[{ filled: isShortListed }, 'event-select-modal-header__shortlist outline']"
            href="#"
            @click.prevent="toggleShortList"
          ></a>
        </div>
      </div>
    </div>
    <div class="event-select-modal-select-content">
      <div v-if="selectionModalData.competitor" class="event-select-modal-select-info">
        <a
          href="#"
          class="event-select-modal-select-chevron left"
          @click.prevent="updateModalData('left', isFirstSelection)"
        ></a>
        <div class="event-select-modal-select-info__container">
          <div class="event-select-modal-select-info__row">
            <!-- silk image -->
            <img
              v-if="selectionModalData.silk_image_url_medium"
              :src="selectionModalData.silk_image_url_medium"
              class="event-select-modal-select-info__silk"
            >
          </div>
          <div class="event-select-modal-select-info__row">
            <div class="event-select-modal-select-info__main-text">{{ competitorString }}</div>
          </div>
          <div class="event-select-modal-select-info__row">
            <div class="event-select-modal-select-info__sub-text">
              <span v-if="isHarness" class="highlight">D</span>
              <span v-else class="highlight">J</span>
              {{ jockeyName }}
              <span class="highlight">T</span>
              {{ trainerName }}
            </div>
          </div>
        </div>
        <a
          href="#"
          class="event-select-modal-select-chevron right"
          @click.prevent="updateModalData('right', isLastSelection)"
        ></a>
      </div>
      <TabGroup
        :key="`tab-group-${selectionModalData.id}`"
        :tab-titles="['Form', 'Odds Comparison']"
        :tab-content="[selectionModalData, selectionModalData]"
        :preselected-tab="tabIndex"
      >
        <EventSelectionModalForm slot="tab-content-0" :selection-data="selectionModalData" />

        <EventSelectionModalOdds
          slot="tab-content-1"
          :selection-win-odds="orderedSelectionWinOdds"
          :selection-place-odds="orderedSelectionPlaceOdds"
          :win-flucs="winFlucsData"
          :place-flucs="placeFlucsData"
        />
      </TabGroup>
    </div>
    <SelectionBlackbookModal />
  </div>
</template>
